import { render, staticRenderFns } from "./ResultItem.vue?vue&type=template&id=4a04c0f3&scoped=true&"
import script from "./ResultItem.vue?vue&type=script&lang=js&"
export * from "./ResultItem.vue?vue&type=script&lang=js&"
import style0 from "./ResultItem.vue?vue&type=style&index=0&id=4a04c0f3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a04c0f3",
  null
  
)

export default component.exports